import { render } from "./NewsFile.vue?vue&type=template&id=8ef55ef4"
import script from "./NewsFile.vue?vue&type=script&lang=js"
export * from "./NewsFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__